// ESM-Huelle fuer lib/scripts/components/CMP_CTextLabel.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CTextLabel (id)
{
    this.construct (id);
    
    this.name = "CTextLabel";
    this.htmlType = "div";

    this.caption = null;
    this.container = null;
    this.properties =
    {
        caption:
        {
            value: "Text Label",
            styles:
            {
    //            fontSize: "3.0vh"
            }
        },
        container:
        {
            styles:
            {
              //  textAlign: "center"
            }
        },
        styles:
        {
      /*      position: "absolute",
            backgroundColor: "#C9C9C9",
            width: "200px",
            height: "50px"*/
        }
    }
}

CTextLabel.prototype = new CComponent;

CTextLabel.prototype.prepare = function ()
{
    this.container = this.addChild (CContainerTable);
    this.container.properties.rows = 1;
    this.container.properties.columns = 1;
    this.container.prepare ();

    this.container.body.rows[0].columns[0].properties = combine (
        this.container.body.rows[0].columns[0].properties, this.properties.container);
    
	
    this.caption = this.container.body.rows[0].columns[0].addChild (CCaption);
    this.caption.properties = combine (this.caption.properties, this.properties.caption);
    
    this.prepared = true;
}

export { CTextLabel };
